import React from 'react'
import { Field } from 'formik'
import { FormControl, TextField } from '@mui/material'
import { ErrorMessage } from 'formik'
import TextError from './TextError'

function Input(props) {
  const { label, name, readOnly = false, placeholder, onChange, ...rest } = props

  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const hasValue = field.value;
        const handleChange = (e) => {
          let value = e.target.value;
          // value = value.trim(); 
          form.setFieldValue(name, value);
          if (onChange) onChange(e);
        };

        const handleBlur = (e) => {
          let value = e.target.value.trim();
          form.setFieldValue(name, value, true);
        };

        return (
          <FormControl fullWidth error={meta.error && meta.touched}>
            <TextField
              fullWidth
              {...field}
              {...rest}
              InputProps={{
                ...rest.InputProps,
              }}
              label={hasValue ? placeholder : label}
              sx={{
                '& .MuiInputLabel-root': {
                  color: '#9CA3AF',
                  // backgroundColor: 'transparent',
                },
                '& .MuiInputLabel-shrink': {
                  backgroundColor: 'transparent',
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#4B5563',
                    borderWidth: '1px',
                  },
                  '&:hover fieldset': {
                    borderColor: '#6B7280',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#6B7280',
                  },
                  backgroundColor: 'transparent',
                },
                '& .MuiInputBase-input': {
                  color: '#E5E7EB',

                },
                
                '& input::placeholder': {
                  color: '#9CA3AF',
                  opacity: 0.7,
                  fontStyle: 'italic',
                  fontSize: '13px',
                },
              }}
              autoComplete="off"
              // InputProps={{ readOnly }}
              onChange={handleChange}
              placeholder={placeholder}
              onBlur={handleBlur}
            />
            <ErrorMessage component={TextError} name={name} />
          </FormControl>
        )
      }}
    </Field>
  )
}

export default Input
